"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiHolidaySavings {
    static getSummary(token) {
        let url = `/holidaysavings/summary`;
        return Client_1.default.httpGet(url, token);
    }
    static getHistory(token, year) {
        let url = `/holidaysavings/history?year=${year}`;
        return Client_1.default.httpGet(url, token);
    }
    // Returns an empty Ok
    static update(token, amount, balance) {
        let url = `/holidaysavings/update`;
        return Client_1.default.httpPost(url, token, { amount: amount, balance: balance });
    }
    // Returns an empty Ok
    static stop(token, immediatePayout, hasBalance) {
        let url = `/holidaysavings/stop`;
        return Client_1.default.httpPost(url, token, { immediatePayout: immediatePayout, hasBalance: hasBalance });
    }
    static confirmPayoutReq(token) {
        let url = `/holidaysavings/confirmpayoutreq`;
        return Client_1.default.httpGet(url, token);
    }
    static getPayoutRequests(token) {
        let url = `/holidaysavings/payouthistory`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiHolidaySavings;
